import { io } from 'socket.io-client';

// Override with REACT_APP_SOCKET_URL in .env.local to point at a local backend.
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://api.play-sequence.com';

// Share links point at the backend, which serves the link-preview tags that
// Facebook and friends read, then sends people on to the site.
const SHARE_URL = (process.env.REACT_APP_SHARE_URL || SOCKET_URL).replace(/\/$/, '');
export const challengeLink = (gameId) => `${SHARE_URL}/share/c/${gameId}`;
export const resultLink = (gameId) => `${SHARE_URL}/share/r/${gameId}`;

let socket;

export const getSocket = () => {
    if (!socket) {
        // Connect over plain HTTP first and upgrade to a websocket when the
        // network allows it. Asking for the websocket first meant players on
        // networks that block websockets (some routers, offices, antivirus)
        // never connected at all: the client does not fall back on its own.
        socket = io(SOCKET_URL, {
            transports: ['polling', 'websocket'],
            reconnection: true,
            reconnectionDelay: 500,
            reconnectionDelayMax: 5000
        });
    }
    return socket;
};

/**
 * Sends a command and resolves with the server's acknowledgement payload, or
 * rejects with the server's error message. Commands mutate; the resulting state
 * arrives for everyone through the `game:update` broadcast.
 */
export const emitCommand = (event, payload) => new Promise((resolve, reject) => {
    getSocket().timeout(10000).emit(event, payload, (timeoutError, response) => {
        if (timeoutError) {
            reject(new Error(getSocket().connected
                ? 'The server took too long to respond. Please try again.'
                : "Can't reach the game server. Check your internet connection, or try another network."));
            return;
        }
        if (!response || response.ok !== true) {
            reject(new Error(response?.message || 'Something went wrong'));
            return;
        }
        resolve(response.data);
    });
});
